export type FilterCategory = 'lead' | 'call' | 'other'

export interface FilterOption {
  id: string
  label: string
  category: FilterCategory
  type: 'select' | 'multiselect' | 'date' | 'checkbox'
  options?: string[]
}

export interface ActiveFilter {
  filterId: string
  value: any
  label: string
}

export interface PageFilterConfig {
  pageId: string
  pageName: string
  enabledFilters: string[]
}

export const AVAILABLE_FILTERS: FilterOption[] = [
  // LEAD Filters
  {
    id: 'unattended_leads',
    label: 'Unattended Leads',
    category: 'lead',
    type: 'select',
  },
  {
    id: 'follow_up_leads',
    label: 'Follow Up Leads',
    category: 'lead',
    type: 'select',
  },
  { id: 'lead_intent', label: 'Lead Intent', category: 'lead', type: 'select' },
  { id: 'lead_type', label: 'Lead Type', category: 'lead', type: 'select' },
  {
    id: 'multi_visit_leads',
    label: 'Multi-Visit Leads',
    category: 'lead',
    type: 'select',
  },
  { id: 'lead_status', label: 'Lead Status', category: 'lead', type: 'select' },

  // CALL Filters
  {
    id: 'inbound_call',
    label: 'Inbound Call',
    category: 'call',
    type: 'select',
  },
  {
    id: 'outbound_calls',
    label: 'Outbound Calls',
    category: 'call',
    type: 'select',
  },
  { id: 'call_agent', label: 'Call Agent', category: 'call', type: 'select' },

  // OTHER Filters
  { id: 'period', label: 'Period', category: 'other', type: 'date' },
  {
    id: 'business_units',
    label: 'Business Units',
    category: 'other',
    type: 'select',
  },
  { id: 'products', label: 'Products', category: 'other', type: 'select' },
  {
    id: 'synced_leads',
    label: 'Synced Leads',
    category: 'other',
    type: 'select',
  },
  { id: 'sync_error', label: 'Sync Error', category: 'other', type: 'select' },
  {
    id: 'channels',
    label: 'Channels',
    category: 'other',
    type: 'checkbox',
    options: ['Google', 'Facebook'],
  },
]

export const DEFAULT_PAGE_CONFIGS: PageFilterConfig[] = [
  {
    pageId: 'campaigns',
    pageName: 'All Campaigns',
    enabledFilters: AVAILABLE_FILTERS.map((f) => f.id),
  },
  {
    pageId: 'leads',
    pageName: 'Leads Management',
    enabledFilters: AVAILABLE_FILTERS.map((f) => f.id),
  },
  {
    pageId: 'conversations',
    pageName: 'Conversations',
    enabledFilters: AVAILABLE_FILTERS.map((f) => f.id),
  },
  {
    pageId: 'workflows',
    pageName: 'Workflows',
    enabledFilters: AVAILABLE_FILTERS.map((f) => f.id),
  },
]
